// extracted by mini-css-extract-plugin
module.exports = {"form":"PasswordRecoveryForm_form__27-C9","submitButton":"PasswordRecoveryForm_submitButton__33hoJ","centered":"PasswordRecoveryForm_centered__3uAja"};